<template>
    <div>

        <div style="padding-top: 5rem; margin-top: 2rem; margin-bottom: 0rem;" >
            <div class="d-table">
                <div class="d-table-cell">
                    <div class="container" style="margin-top: 14px">
                        <h1>DEMO</h1>
                        <h5 class="order-conf" style="color: #5457c1; margin-top: 20px; margin-bottom: 5px">Enter input for Selfpetition AI 🚀</h5>
                        <h2>Then play around with <span style="color: #5457c1">proposed endeavor</span> ideas</h2>

                        <div style="margin-top: 2rem; margin-bottom: 10px; border: 2px solid #032b8d; color: #4a6f8a" class="alert alert-light" role="alert">
                            ✨ The greater the level of detail you provide, the higher quality of your proposed endeavor.
                        </div>
                        <div style="border: 2px solid #032b8d; color: #4a6f8a" class="alert alert-light" role="alert">
                            ✨ This <span style="font-weight: 500">DEMO</span> only drafts <span style="font-weight: 500">PROPOSED ENDEAVOR</span> ideas. Our full Selfpetition AI package also includes:
                            <ul>
                                <li>Fully customized proposed endeavor</li>
                                <li>Endeavor execution plan</li>
                                <li>Substantial merit & national importance (Prong 1)</li>
                                <li>Explanation of how you're well positioned (Prong 2)</li>
                                <li>Justification for labor certification waiver (Prong 3)</li>
                                <li>Proposed list of evidence</li>
                                <li>Suggestions on how to strengthen your petition</li>
                            </ul>
                            Looking for more? We’ve got your <a href="/checkout-selfpetition-ai" style="text-decoration: underline; font-weight: 500">full petition draft</a> covered.
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="d-table" style="padding-top: 3rem; background-color: #f9fafb">
            <div class="d-table-cell">
                <div class="container">

                    <div class="row" style="margin-bottom: 3rem">
                        <h5 class="col-12">Your profile overview</h5>

                        <div class="col-md-8" style="padding-left: 2rem; padding-top: 1rem">
                            <div class="form-group">
                                <label for="name" style="margin-bottom: 3px">Petitioner's name</label>
                                <input type="text" class="form-control" id="name" @input="handleInputChange()" aria-describedby="name" placeholder="Your name" style="border-radius: 5px; border-color: #44ce6f" v-model="userBackground.name">
                            </div>
                            <div class="form-group">
                                <label for="profession" style="margin-bottom: 3px">Profession and job title</label>
                                <input type="text" class="form-control" id="profession" @input="handleInputChange()" aria-describedby="profession" style="border-radius: 5px; border-color: #44ce6f" v-model="userBackground.profession">
                            </div>
                            <div class="form-group">
                                <label for="company" style="margin-bottom: 3px">Current company</label>
                                <input type="text" class="form-control" id="company" @input="handleInputChange()" aria-describedby="company" style="border-radius: 5px; border-color: #44ce6f" v-model="userBackground.company">
                            </div>
                            <div class="form-group">
                                <label for="industry" style="margin-bottom: 3px">Industry or sector that you work in</label>
                                <input type="text" class="form-control" id="industry" @input="handleInputChange()" aria-describedby="industry" style="border-radius: 5px; border-color: #44ce6f" v-model="userBackground.industry">
                            </div>
                            <div class="form-group">
                                <label for="roleDesc" style="margin-bottom: 3px">Describe your professional role — both your current position and the one you plan to pursue in the near future
                                    <ul>
                                        <li style="font-weight: 400">How company or clients benefit from your work?</li>
                                        <li style="font-weight: 400">Who benefits from your work: is it internal team, external clients, other?</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="roleDesc" @input="handleInputChange()" aria-describedby="roleDesc" rows="4" style="border-radius: 5px; border-color: #44ce6f" v-model="userBackground.roleDesc"></textarea>
                            </div>
                        </div>

<!-- Alerts to validate submission-->
                        <div class="col-8" style="padding-left: 2rem; padding-top: 1rem">
                            <div v-if="submittedAlert && !submittedSuccess && !userBackground.name" class="alert alert-warning" role="alert" style="margin-bottom: 5px">
                                <div style="font-weight: 500">Your name is required</div>
                            </div>
                            <div v-if="submittedAlert && !submittedSuccess && !userBackground.profession" class="alert alert-warning" role="alert" style="margin-bottom: 5px">
                                <div style="font-weight: 500">Your profession and job title is required</div>
                            </div>
                            <div v-if="submittedAlert && !submittedSuccess && !userBackground.roleDesc" class="alert alert-warning" role="alert" style="margin-bottom: 5px">
                                <div style="font-weight: 500">Role description is required</div>
                            </div>
                        </div>

                    </div>

                    <div class="row" style="margin-bottom: 3rem">
                        <h5 class="col-12">Proposed endeavor</h5>
                        <div class="col-12" style="padding-left: 2rem; padding-top: 1rem">
                            <div class="form-group">
                                <label for="proposedEndeavor" style="margin-bottom: 3px">Have proposed endeavor idea already? Submit it here to iterate and improve
                                    <ul>
                                        <li style="font-weight: 400">The proposed endeavor is the specific future work or project you intend to carry out in the U.S.</li>
                                        <li style="font-weight: 400">It's ok if you don't have one yet, that’s exactly what this tool is for</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="proposedEndeavor" @input="handleInputChange()" aria-describedby="proposedEndeavor" rows="4" style="border-radius: 5px; border-color: #44ce6f" v-model="userProposedEndeavor.proposedEndeavor"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="proposedEndeavorNiche" style="margin-bottom: 3px">In the endeavor, are you looking to focus on a specific project, client segment, industry, or niche area?
                                    <ul style="margin-bottom: 5px">
                                        <li style="font-weight: 400">It's ok if you don't have endeavor focus yet, we will provide several choices</li>
                                    </ul>
                                    In the endeavor, are you looking to focus on a specific U.S. state or geographic region in the U.S.?
                                    <ul>
                                        <li style="font-weight: 400">If not, we will describe your proposed endeavor as national in scope</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="proposedEndeavorNiche" @input="handleInputChange()" aria-describedby="proposedEndeavorNiche" rows="2" style="border-radius: 5px; border-color: #44ce6f" v-model="userProposedEndeavor.proposedEndeavorNiche"></textarea>
                            </div>
                            <div class="form-group">
                                <label style="margin-bottom: 8px">How do you plan to execute your proposed endeavor in the U.S.?
                                    <div style="font-weight: 400">Select the option that aligns with your previous experience because USCIS expects you to be qualified to carry out the proposed endeavor</div>
                                </label>
                                <div style="margin: 0px 28px 20px">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="executionEmployee" @change="handleInputChange()" name="proposedEndeavorExecution" value="employee" v-model="userProposedEndeavor.executionPlan">
                                        <label class="form-check-label" for="executionEmployee" style="font-weight:500">As an employee</label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="executionEntrepreneur" @change="handleInputChange()" name="proposedEndeavorExecution" value="entrepreneur" v-model="userProposedEndeavor.executionPlan">
                                        <label class="form-check-label" for="executionEntrepreneur" style="font-weight:500">As an entrepreneur</label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="executionConsultant" @change="handleInputChange()" name="proposedEndeavorExecution" value="consultant" v-model="userProposedEndeavor.executionPlan">
                                        <label class="form-check-label" for="executionConsultant" style="font-weight:500">As an independent consultant or contractor</label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="futureProject1" style="margin-bottom: 3px">Vision for the next 2–5 Years: <b>FUTURE</b> work or project
                                    <ul>
                                        <li style="font-weight: 400">What is the goal of this project?</li>
                                        <li style="font-weight: 400">Who will benefit from this project if successful?</li>
                                        <li style="font-weight: 400">What will you contribute to this project?</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="futureProject1" @input="handleInputChange()" aria-describedby="futureProject1" rows="4" style="border-radius: 5px; border-color: #44ce6f" v-model="userProposedEndeavor.futureProject1"></textarea>
                            </div>
                        </div>
                    </div>

                    <div class="row" style="margin-bottom: 3rem">
                        <h5 class="col-12">Substantial merit and national importance</h5>
                        <div class="col-12" style="padding-left: 2rem; padding-top: 1rem">              
                            <div class="form-group">
                                <label for="jobCreation" style="margin-bottom: 3px">Does your role contribute to job creation in the U.S.?
                                    <ul>
                                        <li style="font-weight: 400">This could be through directly hiring employees, or indirectly by enabling other companies to grow and create jobs - for example, through your services, funding, partnerships, or strategic support</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="jobCreation" @input="handleInputChange()" aria-describedby="jobCreation" rows="2" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng1.jobCreation"></textarea>
                            </div>   
                            <div class="form-group">
                                <label for="scaleImpact" style="margin-bottom: 3px">Do your actions affect large number of people - thousands or even millions across the U.S.?
                                    <ul>
                                        <li style="font-weight: 400">This could be through a widely used product, service, policy, or system that has national reach or influence</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="scaleImpact" @input="handleInputChange()" aria-describedby="scaleImpact" rows="2" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng1.scaleImpact"></textarea>
                            </div>   
                            <div class="form-group">
                                <label for="impactOnIndustry" style="margin-bottom: 3px">How your actions benefit anyone <b>BEYOND</b> your employer or direct clients?
                                    <ul>
                                        <li style="font-weight: 400">For example, by influencing industry practices, setting new standards, contributing to open source tools, publishing research, or sharing knowledge through speaking or writing</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="impactOnIndustry" @input="handleInputChange()" aria-describedby="impactOnIndustry" rows="2" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng1.impactOnIndustry"></textarea>
                            </div>   
                            <div class="form-group">
                                <label for="fundsInflow" style="margin-bottom: 3px">Are you involved in facilitating flow of funds from overseas into the U.S.?
                                    <ul>
                                        <li style="font-weight: 400">This could include foreign investments, international partnerships, or securing loans that support U.S. based projects or companies</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="fundsInflow" @input="handleInputChange()" aria-describedby="fundsInflow" rows="2" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng1.fundsInflow"></textarea>
                            </div>   
                        </div>
                    </div>

                    <div class="row" style="margin-bottom: 5rem">
                        <h5 class="col-12">Additional information</h5>
                        <div class="col-12" style="padding-left: 2rem; padding-top: 1rem">
                            <div class="form-group">
                                <label for="additionalInfo" style="margin-bottom: 3px">Is there any other information you would like to add?</label>
                                <textarea class="form-control" id="additionalInfo" @input="handleInputChange()" aria-describedby="additionalInfo" rows="3" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng3.additionalInfo"></textarea>
                            </div>
                        </div>
                    </div>

                    <form  @submit.prevent="submit()" class="row" style="justify-content: center; margin-bottom: 5rem">
                        <div class="col-xl-3 col-sm-5 col-10">
                            <button type="submit" class="btn btn-primary" style="width: 100%; margin-bottom: 5px">Submit</button>
                            <div :class="{ nonvisible: !submitted || submittedSuccess }" class="alert alert-warning" role="alert" style="font-weight: 500; text-align: center">Oops... check your inputs in "Your profile overview"</div>
                        </div>
                        <div v-if="submittedSuccess" class="col-12" style="margin-top: 1rem">
                            <div class="alert alert-primary" role="alert" style="font-weight: 500; text-align: center">
                                <h6>🎉 We are drafting your proposed endeavor 🎉</h6>
                            </div>
                       </div>
                    </form>

                </div>
            </div>
        </div>
    
    </div>
</template>

<script>

import {mapActions} from "vuex";

    export default {
        name: 'GreenCardAiFormProposedEndeavor',
        data () {
            return {
                userBackground: {
                    name: '',
                    profession: '',
                    company: '',
                    industry: '',
                    roleDesc: '',
                },
                userProposedEndeavor: {
                    proposedEndeavor: '',
                    proposedEndeavorNiche: '',
                    executionPlan: [],
                    futureProject1: '',
                },
                userProng1: {
                    jobCreation: '',
                    scaleImpact: '',
                    impactOnIndustry: '',
                    fundsInflow: '',
                },
                userProng3: {
                    additionalInfo: '',
                },
                submitted: false,
                submittedSuccess: false,
                submittedAlert: false,
            }
        },
        methods: {
            ...mapActions('account', ['apply']),
            sendEvent(eventType) {
              if (window.gtag) {
                window.gtag('event', eventType); // google analytics
              }
            },
            handleInputChange() {
                const inputs = this.$el.querySelectorAll('input, textarea');
                inputs.forEach(input => {
                    input.style.color = '#0e314c';
                });
                
                this.submitted = false; // Reset the submission status when any input changes
            },
            markAllInputsGrey() {
                const inputs = this.$el.querySelectorAll('input, textarea');
                inputs.forEach(input => {
                    input.style.color = '#6084a4';
                });
            },
            submit() {
                this.submitted = true;
                this.submittedAlert = true;
                if(this.userBackground.name && this.userBackground.profession && this.userBackground.roleDesc) {
                  this.sendEvent('AI-form-proposed-endeavor');
                    this.apply({
                        userBackground: this.userBackground,
                        userProposedEndeavor: this.userProposedEndeavor,
                        userProng1: this.userProng1,
                        userProng3: this.userProng3,
                    })
                    this.submittedSuccess = true;
                    this.markAllInputsGrey();

                    // Hide the success alert after 5 seconds
                    setTimeout(() => {
                        this.submittedSuccess = false;
                        this.submitted = false;
                    }, 5000);
                }
            }
        }
    }

</script>

<style scoped>

input[type="checkbox"] {
    display: none; /* Hide default checkbox */
}

input[type="checkbox"] + label::before {
    content: '';
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    font-size: 12px;
    color: #44ce6f;
    border: 1px solid #44ce6f;
    border-radius: 4px;
    margin-right: 8px;
    vertical-align: middle;
}

input[type="checkbox"]:checked + label::before {
    content: 'X';
    background-color: #44ce6f;
    color: white;
    border-color: #44ce6f;
}

</style>
